<template>
    <KvModal ref="modal" :id="modalId" @close="onClose">
        <template #title>{{ title }}</template>
        <template #subtitle v-if="subtitle">{{ subtitle }}</template>
        <template #body>
            <div class="payment-fields">
                <p class="payment-hint">{{ hint }}</p>
                <div class="payment-row payment-row-centered mb-3">
                    <div class="payment-field" style="width: 240px; text-align: center;">
                        <label class="payment-label">{{ t('invoices-payment_date') }}</label>
                        <KvDatePicker
                            v-model="localPaidAt"
                            type="datetime"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            variant="outlined"
                        />
                    </div>
                </div>
                <div class="payment-row" v-if="showFinesFields">
                    <div class="payment-field">
                        <label class="payment-label">{{ t('invoices-interest_fines') }}</label>
                        <KvInput
                            v-model="localFines"
                            :money="true"
                            :currency="invoice.currency || 'BRL'"
                            placeholder="0,00"
                            variant="outlined"
                            @input="syncTotal"
                        />
                    </div>
                    <div class="payment-field">
                        <label class="payment-label payment-label-total">{{ t('invoices-total_paid') }}</label>
                        <KvInput
                            v-model="localTotal"
                            :money="true"
                            :currency="invoice.currency || 'BRL'"
                            placeholder="0,00"
                            variant="outlined"
                            class="payment-input-total-kv"
                        />
                    </div>
                </div>
            </div>
        </template>
        <template #footer>
            <kv-button variant="outlined" @click="close">{{ t('invoices-cancel') }}</kv-button>
            <kv-button variant="filled" :loading="loading" @click="confirm">
                {{ t('invoices-yes_mark_as_paid') }}
            </kv-button>
        </template>
    </KvModal>
</template>

<script>
import KvModal from '../../components/modal/modal.vue';
import KvInput from '../../components/inputs/kv-input.vue';
import KvDatePicker from '../../components/inputs/kv-date-picker.vue';

export default {
    name: 'payment-confirm-modal',
    components: { KvModal, KvInput, KvDatePicker },
    props: {
        modalId:   { type: String,  default: 'payment-confirm-modal' },
        invoice:   { type: Object,  required: true },
        title:     { type: String,  default: '' },
        subtitle:  { type: String,  default: '' },
        hint:      { type: String,  default: '' },
        loading:   { type: Boolean, default: false },
        showFinesFields: { type: Boolean, default: true }
    },
    data() {
        return {
            localPaidAt: '',
            localFines: 0,
            localTotal: 0
        };
    },
    methods: {
        open() {
            this.localFines = 0;
            this.localTotal = Number(this.invoice?.total || 0);
            
            const now = new Date();
            const pad = n => String(n).padStart(2, '0');
            this.localPaidAt = `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())} ${pad(now.getHours())}:${pad(now.getMinutes())}:${pad(now.getSeconds())}`;
            
            this.$nextTick(() => this.$refs.modal && this.$refs.modal.open());
        },
        close() {
            this.$refs.modal && this.$refs.modal.close();
        },
        onClose() {
            this.localFines = 0;
            this.localTotal = 0;
            this.localPaidAt = '';
            this.$emit('close');
        },
        syncTotal() {
            this.localTotal = Number(this.invoice?.total || 0) + Number(this.localFines || 0);
        },
        confirm() {
            this.$emit('confirm', {
                paid_at:        this.localPaidAt,
                interest_fines: Number(this.localFines || 0),
                total_paid:     Number(this.localTotal ?? Number(this.invoice?.total || 0))
            });
        }
    }
};
</script>

<style lang="scss" scoped>
.payment-fields {
    display: flex;
    flex-direction: column;
    gap: 16px;
}

.payment-hint {
    font-size: 14px;
    color: #6B7280;
    margin: 0 0 4px;
    text-align: center;
}

.payment-row {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 12px;
}

.payment-row-centered {
    display: flex;
    justify-content: center;
}

.payment-field {
    display: flex;
    flex-direction: column;
    gap: 6px;
}

.payment-label {
    font-size: 12px;
    font-weight: 500;
    color: #6B7280;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    margin: 0;

    &.payment-label-total { color: #059669; }
}

.payment-input-total-kv {
    ::v-deep .kv-input-wrapper {
        border-color: #A7F3D0;
        .kv-native-input { color: #059669; font-weight: 500; }
        &:focus-within {
            border-color: #059669;
            box-shadow: 0 0 0 3px rgba(5, 150, 105, 0.12);
        }
    }
}
</style>
